export const tapNdonateModels = [
  { value: 'WPC32', regex: /^WPC32[A-Z0-9]{8,14}$/ }
];
